<template>
  <div class="hardware-main">
    <div class="hardware-box">
      <div class="hardware-title">{{ $t('hardthree.hardware-title1') }}</div>
      <div class="hardware-li">{{ $t('hardthree.hardware-li1') }}</div>
      <div class="hardware-li">{{ $t('hardthree.hardware-li2') }}</div>
      <div class="hardware-li">{{ $t('hardthree.hardware-li3') }}</div>
      <div class="hardware-title">{{ $t('hardthree.hardware-title2') }}</div>
      <div class="hardware-li">{{ $t('hardthree.hardware-li4') }}</div>
      <div class="hardware-li">{{ $t('hardthree.hardware-li5') }}</div>
      <div class="hardware-li">{{ $t('hardthree.hardware-li6') }}</div>
      <div class="hardware-li">{{ $t('hardthree.hardware-li7') }}</div>
      <div class="hardware-li">{{ $t('hardthree.hardware-li8') }}</div>
      <div class="hardware-li">{{ $t('hardthree.hardware-li9') }}</div>
      <div class="hardware-li">{{ $t('hardthree.hardware-li10') }}</div>
      <div class="hardware-li">{{ $t('hardthree.hardware-li11') }}</div>
      <div class="hardware-title">{{ $t('hardthree.hardware-title3') }}</div>
      <div class="hardware-li">{{ $t('hardthree.hardware-li12') }}</div>
      <div class="hardware-li">{{ $t('hardthree.hardware-li13') }}</div>
      <div class="hardware-li">{{ $t('hardthree.hardware-li14') }}</div>
      <div class="hardware-li">{{ $t('hardthree.hardware-li15') }}</div>
      <div class="hardware-li">{{ $t('hardthree.hardware-li16') }}</div>
      <div class="hardware-li">{{ $t('hardthree.hardware-li17') }}</div>
      <div class="hardware-title">{{ $t('hardthree.hardware-title4') }}</div>
      <div class="hardware-li">{{ $t('hardthree.hardware-li18') }}</div>
      <div class="hardware-li">{{ $t('hardthree.hardware-li19') }}</div>
      <div class="hardware-li">{{ $t('hardthree.hardware-li20') }}</div>
      <div class="hardware-li">{{ $t('hardthree.hardware-li21') }}</div>
      <div class="hardware-title">{{ $t('hardthree.hardware-title5') }}</div>
      <div class="hardware-li">{{ $t('hardthree.hardware-li22') }}</div>
      <div class="hardware-li">{{ $t('hardthree.hardware-li23') }}</div>
      <div class="hardware-li">{{ $t('hardthree.hardware-li24') }}</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {},
};
</script>

<style scoped>
</style>